import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Amplify } from 'aws-amplify';

const getRedirectUrls = () => {
  // Cognito Hosted UI의 callback/logout URL은 "정확히 일치"해야 해서
  // /photo 같은 경로는 login_redirect로 복귀 처리하므로 origin 기반으로 통일한다.
  // redirect URI 후보가 여러 개면(슬래시 유무 등) "authorize 요청"과 "token 교환"에서
  // 다른 값이 선택되어 code->token 교환이 실패하는 경우가 있어 1개로 고정한다.
  const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000';
  return [origin];
};

const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'ap-northeast-2_mQ1rnUVkY', // IMPORTANT: This needs to be replaced with your actual User Pool ID
      userPoolClientId: '5i61j6hmvsubje5en96ull5mr6',
      loginWith: {
        oauth: {
          domain: 'ap-northeast-2mq1rnuvky.auth.ap-northeast-2.amazoncognito.com',
          // NOTE: fetchUserAttributes/updateUserAttributes는 Cognito GetUser/UpdateUserAttributes를 호출하며
          // access token에 aws.cognito.signin.user.admin scope가 필요합니다.
          scopes: ['openid', 'email', 'profile', 'aws.cognito.signin.user.admin'],
          redirectSignIn: getRedirectUrls(),
          redirectSignOut: getRedirectUrls(),
          responseType: 'code',
        }
      }
    }
  }
};

Amplify.configure(amplifyConfig);

// n8n REST API로 홈페이지 로그 전송 함수
export const sendLogToN8n = async ({ type, log }) => {
  try {
    await fetch('https://bshong-n8n.ngrok.io/webhook/homepage-log', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': '69420'
      },
      body: JSON.stringify({ type, log, created_at: new Date().toISOString() })
    });
  } catch (err) {
    // 로그 전송 실패는 조용히 무시
    if (window?.console) console.error('n8n 로그 전송 에러', err);
  }
};

// 전역 에러 핸들러를 통한 JS Runtime Exception 로그 전송
window.onerror = function (msg, url, line, col, error) {
  sendLogToN8n({
    type: 'error',
    log: { message: msg, url, line, col, stack: error?.stack }
  });
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);